import React from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { HashLink } from 'react-router-hash-link';
import { addAnalyticEvent } from '../../analytics/common';
import { linkToLearnMore } from '../../analytics/outboundLinks';

export function VisitPrivacyCenter() {

  const handleClick = () => {
    addAnalyticEvent(linkToLearnMore);
  };

  return (
    <div className="sui-grid sui-gap-4">
      <Typography variant="h2" weight="display">
        VISIT THE PRIVACY &amp; SECURITY CENTER
      </Typography>

      <Typography variant="body-base" height="none">
        At The Home Depot, we appreciate that you trust us with your personal information,
        and we&apos;re committed to using your information in ways that create value for you.
        Visit the Privacy &amp; Security Center to learn about what we do with your data and
        access tools to take actions.
      </Typography>

      <div className="sui-grid sui-grid-cols-8">
        <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
        <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3">
          <HashLink to="/privacy/overview" style={{ textDecoration: 'none' }}>
            <Button fullWidth variant="secondary" onClick={handleClick}>
              Learn more
            </Button>
          </HashLink>
        </div>
      </div>
    </div>
  );
}
